var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","title":`Paciente ${_vm.data.pacienteNome}`},scopedSlots:_vm._u([{key:"footer",fn:function({cancel}){return [_c('rkm-button',{on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('Form',{ref:"Form",attrs:{"id":_vm.data.pacienteId},on:{"loaded":_vm.loaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }